// extracted by mini-css-extract-plugin
export default {"portrait":"About_portrait__TZNEP","modalContainer":"About_modalContainer__iPeUw"};